"use client";

import { createRef } from "react";
import { values } from "mobx";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import VerticalBlock from "../blocks/TerracedGridTheme/Terrace";

import classNames from "classnames";
import styles from "./styles/StaticGrid.module.scss";
import { useStores } from "../../stores/useStores";
import { observer } from "mobx-react";

const pageBodyClassName = classNames({
  [styles.pageBody]: true,
});

const transitionClassNames = {
  exit: styles.transitionExit,
  exitActive: styles.transitionExitActive,
};

const TerracedGrid = observer(
  (props: { blockPromises: { [key: string]: Promise<any> } }) => {
    const { gridStore, userStore, modalStore } = useStores();
    const content = values(gridStore.blocks).filter(
      (blockObj) => blockObj.type !== "hero",
    );
    // map terrace always renders last, independent of block order
    const orderedContent = [
      ...content.filter((blockObj) => blockObj.type !== "map"),
      ...content.filter((blockObj) => blockObj.type === "map"),
    ];

    const handleClick = () => {
      modalStore.addModal({ type: "terraceManagementModal" });
    };

    return (
      <div className={pageBodyClassName}>
        {/* TransitionGroup keeps a removed terrace mounted long enough to play
            its CSSTransition exit (a pure-CSS grid-row collapse + fade) before
            unmounting it. */}
        <TransitionGroup component={null} appear={false} enter={false}>
          {orderedContent.map((blockObj, index) => {
            const nodeRef = createRef<HTMLElement>();
            return (
              <CSSTransition
                key={blockObj.id}
                classNames={transitionClassNames}
                timeout={500}
                nodeRef={nodeRef}
              >
                <VerticalBlock
                  ref={nodeRef}
                  blockObj={blockObj}
                  aboveTheFold={index === 0}
                  initialBlockPromise={props.blockPromises[blockObj.id] ?? null}
                />
              </CSSTransition>
            );
          })}
        </TransitionGroup>
        {gridStore.blocks.size === 0 && userStore.isEditor && (
          <div className={styles.noContent}>
            You haven&#39;t added any terraces yet!
            <div>
              <button onClick={handleClick}>Add One Now</button>
            </div>
          </div>
        )}
      </div>
    );
  },
);

export default TerracedGrid;
